import { client } from '../sanityProject/sanityClient';
import { useBlog } from '../context/BlogContext';
import { useEffect } from 'react';

const BlogRealtimeListener = () => {
  const { fetchPosts } = useBlog();

  useEffect(() => {
    const sub = client
      .listen('*[_type=="blogPost"]', {}, { events: ['create','update','delete','publish'] })
      .subscribe(() => fetchPosts());

    return () => sub.unsubscribe();
  }, [fetchPosts]);

  return null;
};

export default BlogRealtimeListener;